// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"9435a4f3","104":"23d8f45a","241":"17c71f40","512":"913c5d70"}[chunkId] + ".css";
};